module.exports = __webpack_public_path__ + "static/img/file_powershell.71a999e9.png";